import { ButtonGroup, IconButton, Stack, Tooltip } from "@chakra-ui/react";
import { useNavigate } from 'react-router-dom';
import { CustomCellRendererProps } from "ag-grid-react";
import { FaDochub, FaEdit, FaList, FaShare, FaWpforms, FaWrench } from "react-icons/fa";
import ProgressLoader from "../../../../components/progressLoader";
import { useState } from "react";
import AddNewSharedProjectButton from "../../../../components/sharedprojects/addNewButton/addNewProjectButton";
import DeleteProjectButton from "./ConfirmButtons/deleteSharedProjectButton";
import EditProjectButton from "../../../../components/projects/editProjectButton/editProjectButton";
import { checkOrgAccess } from "../../../../helpers/authHelper";


export default (params: CustomCellRendererProps) => {

    const props = params as any;

    const [isLoading, SetIsLoading] = useState(false);


    const handleOnClickOpen = () => {
       
        props.openAssetDialog(params.value);
    }
  

    return (
        <>
            {isLoading ? <ProgressLoader /> :
                <Stack direction="row" margin={1} spacing={4}>
                    <ButtonGroup>
                        <Tooltip label='Details'>
                            <IconButton icon={<FaList />} aria-label={'Details'} size='sm' colorScheme='brand' variant='outline' onClick={handleOnClickOpen} />
                        </Tooltip>
                        {/* <Tooltip label='Attachments'>
                            <IconButton icon={<FaWpforms />} aria-label={'Attachments'} size='sm' colorScheme='brand' variant='outline'  />
                        </Tooltip>
                        <Tooltip label='Attachments'>
                            <IconButton icon={<FaShare />} aria-label={'Share'} size='sm' colorScheme='brand' variant='outline' />
                        </Tooltip> */}
                    </ButtonGroup>
                </Stack>
            }

        </>




    )
}